module.exports = __webpack_public_path__ + "media/assets/icons/mail-48032151aa674af2b0d6213b4f7948b6.svg";